import type { ComponentProps } from 'react';
import { createRoot } from 'react-dom/client';
import { initializeCrowdinIframeContext } from '../lib/crowdin-iframe-context';
import { readPageProps } from '../lib/page-props';
import { LoginPage } from '../pages/LoginPage';

initializeCrowdinIframeContext();

const props = readPageProps<ComponentProps<typeof LoginPage>>();

createRoot(document.getElementById('root')!).render(<LoginPage {...props} />);
